import { useTranslation } from 'react-i18next'

export function SkipToContent() {
  const { t } = useTranslation()

  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[500] focus:rounded-md focus:bg-primary-600 focus:px-4 focus:py-2 focus:text-white focus:shadow-lg"
    >
      {t('aria.skipToContent')}
    </a>
  )
}
